export const MAX_RELATIONSHIP_LABEL_LENGTH = 80;

export function normalizeRelationshipLabel(value: string) {
  return value.trim().replace(/\s+/g, " ");
}
export function validateRelationshipSelection({
  sourceCustomerId,
  targetCustomerId,
  targetKind,
  relatedName,
  relationshipLabel,
  knownCustomerIds,
}: {
  sourceCustomerId: string;
  targetCustomerId: string;
  targetKind: "customer" | "person";
  relatedName: string;
  relationshipLabel: string;
  knownCustomerIds: Set<string>;
}): string | null {
  if (!sourceCustomerId || !knownCustomerIds.has(sourceCustomerId)) {
    return "Choose a valid customer";
  }
  if (targetKind === "customer") {
    if (!targetCustomerId || !knownCustomerIds.has(targetCustomerId) || targetCustomerId === sourceCustomerId) {
      return "Choose a different customer to connect";
    }
  } else if (!normalizeRelationshipLabel(relatedName)) {
    return "Enter the person's name";
  }

  const normalizedLabel = normalizeRelationshipLabel(relationshipLabel);
  if (!normalizedLabel) return "Enter a relationship label";
  if (normalizedLabel.length > MAX_RELATIONSHIP_LABEL_LENGTH) {
    return `Relationship labels can be at most ${MAX_RELATIONSHIP_LABEL_LENGTH} characters`;
  }
  return null;
}
